import { Button as MaterialButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Listing } from '../components/Pages/Listing';
import BaseLayout from '../components/layout/base-layout';
import MatchingRoundsTable from '../components/tables/matching-rounds-table';
import { MatchingRoundsProvider } from '../contexts/matching-rounds-context';
import { UserContext } from '../contexts/user-context';
import { Pages } from '../router/constants';
import { ProtectedRouteProps } from '../router/type';
import { isMobile } from '../utils/functions';
import { CLASS_TRACKING } from '../utils/tracking_class';

function MatchingRounds({ user }: ProtectedRouteProps) {
  const { hasAccessToAction } = useContext(UserContext);

  return (
    <BaseLayout user={user} fullWidth hiddenFooter={isMobile()}>
      <Listing
        title='Matching Rounds'
        actions={[
          {
            key: 'new-round',
            label: 'New Round',
            hidden: !hasAccessToAction('matchingRound.create'),
            component: (
              <MaterialButton
                className={CLASS_TRACKING.ENTITY_ACTION}
                data-testid='button-new-round'
                component={Link}
                to={Pages.NEW_MATCHING_ROUND}
                startIcon={<AddIcon />}
                variant='contained'
                color='primary'
              >
                Round
              </MaterialButton>
            ),
          },
        ]}
      >
        <MatchingRoundsTable />
      </Listing>
    </BaseLayout>
  );
}

function MatchingRoundsPage(props: ProtectedRouteProps) {
  return (
    <MatchingRoundsProvider>
      <MatchingRounds {...props} />
    </MatchingRoundsProvider>
  );
}

export default MatchingRoundsPage;
